/* Middleware */
import auth from '@/middleware/auth';

export default [
    {
        path: '/companies',
        name: 'companies',
        meta: {
            layout: 'main',
            middleware: [auth]
        },
        component: () => import('@/views/company/CompaniesView')
    },
    {
        path: '/companies/show',
        name: 'companies.show',
        meta: {
            layout: 'main',
            middleware: [auth]
        },
        component: () => import('@/views/company/CompanyShowView')
    },
    {
        path: '/companies/search',
        name: 'companies.search',
        meta: {
            layout: 'main',
            middleware: [auth]
        },
        component: () => import('@/views/company/CompanySearchView')
    }
];